/**
 * Public marketing-site facts. Everything a lawyer, a designer, or a launch
 * checklist might need to change lives here rather than inside a page.
 */

export const SITE = {
  name: 'Shoutt',
  tagline: 'Rent what you need. From students on your own campus.',
  intro:
    'Shoutt is a campus-only rental marketplace. Verified college students lend what they already own, borrow what they need for a day or a week, and settle up with a deposit that both sides can see.',
  url: 'https://shoutt.live',
} as const;

export const CONTACT = {
  email: 'support@shoutt.live',
  grievanceEmail: 'grievance@shoutt.live',
} as const;

/**
 * Store listings are not live yet, so the CTAs render as "coming soon" badges.
 * Set a URL here and the badge becomes a real link — no other file changes.
 */
export const STORE_LINKS: { ios: string | null; android: string | null } = {
  ios: null,
  android: null,
};

/**
 * PLACEHOLDERS — replace with the registered entity details before launch.
 * These strings are rendered verbatim in the Terms and Privacy pages.
 */
export const LEGAL_ENTITY = {
  name: '[LEGAL ENTITY NAME]',
  address: '[REGISTERED ADDRESS]',
  jurisdiction: '[CITY], India',
  grievanceOfficer: '[GRIEVANCE OFFICER NAME]',
} as const;

/** Shown as "Last updated" on both legal pages. */
export const LEGAL_LAST_UPDATED = '19 August 2026';

/** Commercial terms quoted in the Terms page — mirrors the server defaults in
 *  server/src/models/platformSettings.model.ts. Update both together. */
export const FEE_TERMS = {
  commissionPct: 20,
  gstPct: 18,
  settlementFeePct: 3,
} as const;
